// Class: motion.easing.Elastic

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function motion_easing__$Elastic_ElasticEaseIn() {return require("./../../motion/easing/_Elastic/ElasticEaseIn");}
function motion_easing__$Elastic_ElasticEaseInOut() {return require("./../../motion/easing/_Elastic/ElasticEaseInOut");}
function motion_easing__$Elastic_ElasticEaseOut() {return require("./../../motion/easing/_Elastic/ElasticEaseOut");}

// Constructor

var Elastic = function(){}

// Meta

Elastic.__name__ = ["motion","easing","Elastic"];
Elastic.__isInterface__ = false;
Elastic.prototype = {
	
};
Elastic.prototype.__class__ = Elastic.prototype.constructor = $hxClasses["motion.easing.Elastic"] = Elastic;

// Init



// Statics

Elastic.easeInWith = function(a,p) {
	return new (motion_easing__$Elastic_ElasticEaseIn().default)(a,p);
}
Elastic.easeInOutWith = function(a,p) {
	return new (motion_easing__$Elastic_ElasticEaseInOut().default)(a,p);
}
Elastic.easeOutWith = function(a,p) {
	return new (motion_easing__$Elastic_ElasticEaseOut().default)(a,p);
}
Elastic.easeIn = new (motion_easing__$Elastic_ElasticEaseIn().default)(0.1,0.4)
Elastic.easeInOut = new (motion_easing__$Elastic_ElasticEaseInOut().default)(0.1,0.4)
Elastic.easeOut = new (motion_easing__$Elastic_ElasticEaseOut().default)(0.1,0.4)

// Export

exports.default = Elastic;